export { State, Getter, Action, Mutation, namespace } from './bindings';



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuex-class/lib/index.js
// module id = null
// module chunks = 